import React from 'react';
import { PRICE, PRICE_BEFORE } from '../data/matikka';

/**
 * Honest announcement bar: no fake timers or counters.
 */
export function CountdownBar() {
  return <div className="sticky top-0 z-50 w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-56" data-mp="307v4uiwkcixx">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-x-3 whitespace-nowrap px-4 py-2.5 text-xs sm:text-sm" data-id="element-57" data-mp="2vcpb4xwx5zza">
        <span className="relative flex h-2 w-2 shrink-0" aria-hidden="true" data-id="element-58" data-mp="2meww7uv40ucf">
          <span className="relative inline-flex h-2 w-2 rounded-full bg-red-300" data-id="element-59" data-mp="2hfah1fvq140z" />
        </span>
        <span className="text-stone-50/80" data-id="element-60" data-mp="2cg7mwqha4i7s">
          <span className="hidden sm:inline" data-id="element-61" data-mp="2ch8xyuyap4pi">Tutustumishinta </span>
          <span className="sm:hidden" data-id="element-62" data-mp="28evuyeaxnkwf">Nyt: </span>
        </span>
        <span className="font-semibold text-stone-50" data-id="element-63" data-mp="28gp35y172d6j">{PRICE}</span>
        <s className="text-stone-50/50" data-id="element-64" data-mp="anjgk89c9ens">{PRICE_BEFORE}</s>
        <span className="hidden text-stone-50/80 sm:inline" data-id="element-65" data-mp="6n990r5weg6t">· Kertamaksu · 7 päivän tyytyväisyystakuu</span>
      </div>
    </div>;
}